import { notification } from "../../../services";
import { CopyOutlined } from "@ant-design/icons";
import React from "react";
import ReactGA from "react-ga4";


type Props = {
  label: string;
  isMobile: boolean;
  value: string;
  isOwnMessage: boolean;
  type?: "email" | "phone";
};
export const CopyableField = ({ label, value, type, isMobile, isOwnMessage }: Props) => {

  const handleTracking = () => {
    if (!isOwnMessage) {
      ReactGA.event({
        category: "Slanje kontakt podataka XML",
        action: "Click",
        label: `Primatelj je kliknuo na ${type === "email" ? "e-mail" : "broj telefona"}`
      });

    }
  }

  const handleClick = () => {
    navigator.clipboard.writeText(value);
    notification.show(`${label} kopiran`);
    handleTracking()
  }

  if (isMobile) {
    const href = type === "email" ? `mailto:${value}` : type === "phone" ? `tel:${value}` : undefined;
    return (
      <div>
        {label}:{" "}
        <a href={href} onClick={handleTracking} style={{ color: "inherit", textDecoration: "underline" }}>
          {value}
        </a>
      </div>
    )
  }



  return (
    <div>
      {label}:{" "}
      <span
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={handleClick}
      >
        {value}
        <CopyOutlined style={{ marginLeft: 6 }} />
      </span>
    </div>
  )
};





// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/CopyableField.tsx